import * as React from 'react';
import * as main from '../../styles/main.module.scss';
import * as speaker from './speaker.module.scss';

export const Speaker = ({ title, speakerName, speakerProf, speakerPhoto, dataProfList, container, iconColor}) => {
  return (
    <section className={speaker.speaker}>
      <div className={"container"}>
        <div className={`${speaker.speaker__container} ${container}`}>
          <div className={speaker.speaker__info}>
            <h2 className={main.mainTitle}>{ title }</h2>
            <p className={speaker.speaker__name}>{ speakerName }</p>
            <p className={speaker.speaker__prof}>{ speakerProf }</p>
          </div>
          <ul className={speaker.speaker__list}>
          {
            dataProfList.map((elem, index) => (
              <li className={speaker.speaker__item} key={index}>
                <svg className={speaker.speaker__itemIcon} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g clip-path="url(#clip0_59_424)">
                    <path d="M19.5833 9.58333C19.3533 9.58333 19.1667 9.77 19.1667 10C19.1667 15.0542 15.0542 19.1667 10 19.1667C4.94583 19.1667 0.833333 15.0542 0.833333 10C0.833333 4.94583 4.94583 0.833333 10 0.833333C12.915 0.833333 15.6458 2.2175 17.3733 4.55333L9.40167 12.525L6.46083 9.58417C6.29833 9.42167 6.03417 9.42167 5.87167 9.58417C5.70917 9.74667 5.70917 10.0108 5.87167 10.1733L9.1075 13.4092C9.27 13.5717 9.53417 13.5717 9.69667 13.4092L18.2117 4.89333C18.3533 4.75167 18.3742 4.52833 18.2608 4.36333C16.3933 1.63167 13.305 0 10 0C4.48583 0 0 4.48583 0 10C0 15.5142 4.48583 20 10 20C15.5142 20 20 15.5142 20 10C20 9.77 19.8133 9.58333 19.5833 9.58333Z" fill={iconColor}/>
                  </g>
                  <defs>
                    <clipPath id="clip0_59_424">
                      <rect width="20" height="20" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                {elem.item}
              </li>
            ))
          }
          </ul>
          <img
            className={speaker.speaker__img}
            src={ speakerPhoto }
            alt={ speakerName }
          />
        </div>
      </div>
    </section>
  );
};
